import type {
  CardItemArticleData,
  PaginationData,
  SelectOption,
  StoreCardItemPromoData,
} from '@presentation/components';

export interface ArticleListPageFormOptions {
  categoryTags: SelectOption<string>[];
}

export interface ArticleListPageFormValues {
  tagId?: string;
  title?: string;
}

export interface ArticleListPageData {
  items: (CardItemArticleData | StoreCardItemPromoData)[];
  isPromoItem: (index: number, size: number) => boolean;

  formOptions: ArticleListPageFormOptions;

  pagination: PaginationData;
  loading?: boolean;
}

export interface ArticleListPageProps extends ArticleListPageData {}
